/**
 * /skills — install + configure skills (reusable agent atoms).
 *
 * Mirrors the old Next.js RSC at `app/(dashboard)/skills/page.tsx`.
 * The catalog and per-team installed list are pre-fetched server-side
 * so the client mounts with real data and no spinner.
 */

import { useLoaderData } from "react-router-dom";

import { SkillsBrowser } from "@/features/skills/skills-browser";
import { SkillsPageHeader } from "@/features/skills/skills-page-header";
import { api } from "@/lib/api";
import type { InstalledSkillsResponse, SkillCatalogResponse } from "@/lib/types";

interface SkillsLoaderData {
  catalog: SkillCatalogResponse;
  installed: InstalledSkillsResponse;
}

export async function skillsLoader(): Promise<SkillsLoaderData> {
  const [catalog, installed] = await Promise.all([
    api<SkillCatalogResponse>("/skills/catalog"),
    api<InstalledSkillsResponse>("/skills/installed"),
  ]);
  return { catalog, installed };
}

export default function SkillsRoute() {
  const { catalog, installed } = useLoaderData() as SkillsLoaderData;
  return (
    <section className="space-y-4">
      <SkillsPageHeader />
      <SkillsBrowser
        initialCatalog={catalog.items}
        initialCategories={catalog.categories}
        initialInstalled={installed.items}
      />
    </section>
  );
}
